import { useState } from "react"
import { Navigate, useNavigate } from "react-router-dom"

export const STPGroupButton = (props) => {

    const { SetActiveBtn, ActiveBtn } = props
    const Navigate = useNavigate()

    return (

        <>
            <div className="row  m-0 mb-3 master_border">

                <div className="col-2 py-2 " >
                    {/* <input type="date" class="form-control" id="exampleFormControlInput1" placeholder="name@example.com"></input> */}
                </div>

                <div className="col-10 py-2 " >
                    <div className="btn-group float-end " role="group" aria-label="Default button group">
                        {/* <button type="button" class={ActiveBtn === "Daily Preventive Work" ? "active_group_btn border_radius1" : "btn btn-outline-primary2"} onClick={() => SetActiveBtn("Daily Preventive Work")}>Daily Preventive Work</button> */}
                        <button type="button" class={ActiveBtn === "STP Official Visit" ? "active_group_btn border_radiusn" : "btn btn-outline-primary2"} onClick={() => SetActiveBtn("STP Official Visit")}> Official Visit</button>
                        <button type="button" class={ActiveBtn === "STP Work Progress" ? "active_group_btn" : "btn btn-outline-primary2"} onClick={() => SetActiveBtn("STP Work Progress")}>Work Progress</button>

                    </div>
                </div>

            </div>
        </>
    )
}